import { z } from 'zod';
import { CommentVisibilitySchema } from './comments';
import { ActorSchema } from './events';
import { TicketEventTypeSchema } from './tickets';

/**
 * One row of `GET /tickets/{id}/history` (S-05-11): raw values are ids (`from`/`to`), the
 * display values were captured when the change happened. `visibility: 'internal'` rows are
 * hidden from customers.
 */
export const TicketEventSchema = z.object({
  id: z.uuid(),
  ticketId: z.uuid(),
  type: TicketEventTypeSchema,
  actor: ActorSchema,
  /** System column name or `cf_` key for `field_changed`; null otherwise. */
  field: z.string().nullable(),
  from: z.unknown(),
  to: z.unknown(),
  fromDisplay: z.string().nullable(),
  toDisplay: z.string().nullable(),
  visibility: CommentVisibilitySchema,
  occurredAt: z.iso.datetime(),
});
export type TicketEvent = z.infer<typeof TicketEventSchema>;

export const TicketHistoryResponseSchema = z.object({
  items: z.array(TicketEventSchema),
  nextCursor: z.string().nullable(),
});
export type TicketHistoryResponse = z.infer<typeof TicketHistoryResponseSchema>;
